import React, {Component} from 'react';
import {Col, Row, Card, Button, Icon} from 'antd';
import EvaluationPorcentage from 'components/eCommerce/EvaluationPorcentage';
import {auth, database} from '../../../firebase/firebase';
import {cold} from 'react-hot-loader';
import Moment from 'moment';
import {func} from 'prop-types';
import {calculateEvaluationProgress} from '../../../util/evaluationProgress';

class EvaluationsList extends Component {
    constructor(props) {
        super(props);
        this.state = {
            user: {},
            userId: 1,
            urlId: 0,
            series: {},
            accessed_serie: {},
            solvedEvaluationsLoaded: false,
            solvedEvaluations: [],
            progressByEvaluation: {},
            evaluations: []
        };
    }

    getSeriesInformation() {
        var _this = this;
        database
            .doc('/series/' + _this.state.urlId)
            .get()
            .then(function (doc) {
                if (doc.exists) {
                    _this.setState({
                        series: doc.data()
                    });
                    database
                        .collection('/evaluations')
                        .where('series', '==', _this.state.urlId)
                        .get()
                        .then(function (snapshot) {
                            var evs = [];

                            snapshot
                                .docs
                                .forEach(function (damn) {
                                    database
                                        .collection('/questions')
                                        .where('evaluation', '==', damn.id)
                                        .get()
                                        .then(function (fack) {
                                            damn.questions = fack.docs;
                                            damn.total = fack.docs.length;
                                            evs.push(damn);
                                            if (evs.length == snapshot.docs.length) {
                                                var sorted = evs.sort(function (a, b) {
                                                    if (a.data().order < b.data().order) {
                                                        return -1;
                                                    }
                                                    if (a.data().order > b.data().order) {
                                                        return 1;
                                                    }
                                                    return 0;
                                                });
                                                _this.setState({evaluations: sorted}, function () {
                                                    _this.getUserEvaluations();
                                                });
                                            }
                                        });
                                });
                        });
                } else {}
            });
    }

    getUserEvaluations() {
        var _this = this;
        var solvedEvaluationsPath =
            'users/' +
            _this.state.userId +
            '/accesed_series/' +
            _this.state.accessed_serie.id +
            '/solved_evaluations';

        database
            .collection(solvedEvaluationsPath)
            .get()
            .then(function (snapshot) {
                var solvedEvaluationPromises = _this.state.evaluations.map(function (evaluation) {
                    var attempts = snapshot.docs
                        .filter((attempt) => attempt.data().evaluation_id === evaluation.id)
                        .sort(function (a, b) {
                            return Number(a.data().attempt_number) - Number(b.data().attempt_number);
                        });

                    if (attempts.length > 0) {
                        return Promise.resolve(attempts[attempts.length - 1]);
                    }

                    return database
                        .collection(solvedEvaluationsPath)
                        .add({
                            correct_answers: '0',
                            wrong_answers: '0',
                            timestamp: Moment(new Date()).format('DD/MM/YYYY HH:mm:ss'),
                            grade: '0',
                            evaluation_id: evaluation.id,
                            porcentage: '0',
                            status: 'Por iniciar',
                            attempt_number: '1',
                            evaluation_name: evaluation.data().title
                        })
                        .then(function (documentReference) {
                            return database.doc(documentReference.path).get();
                        });
                });

                return Promise.all(solvedEvaluationPromises);
            })
            .then(function (solvedEvaluations) {
                return _this.loadEvaluationProgress(solvedEvaluationsPath, solvedEvaluations);
            })
            .catch(function (error) {
                console.error('Error loading evaluation progress: ', error);
            });
    }

    loadEvaluationProgress(solvedEvaluationsPath, solvedEvaluations) {
        var _this = this;
        var progressPromises = solvedEvaluations.map(function (solvedEvaluation) {
            var solvedEvaluationData = solvedEvaluation.data();
            var evaluationId = solvedEvaluationData.evaluation_id;
            var evaluation = _this.state.evaluations.find(function (item) {
                return item.id === evaluationId;
            });
            var storedPorcentage = Number(solvedEvaluationData.porcentage) || 0;
            var isFinished =
                solvedEvaluationData.status === 'Aprobado' || solvedEvaluationData.status === 'Reprobado';

            if (!evaluation || isFinished) {
                return Promise.resolve({
                    evaluationId: evaluationId,
                    porcentage: isFinished ? 100 : storedPorcentage
                });
            }

            var solvedQuestionsPath =
                solvedEvaluationsPath + '/' + solvedEvaluation.id + '/solved_questions';

            return database
                .collection(solvedQuestionsPath)
                .get()
                .then(function (solvedQuestions) {
                    var porcentage = calculateEvaluationProgress(
                        solvedQuestions.docs,
                        evaluation.questions || []
                    );
                    return {evaluationId: evaluationId, porcentage: porcentage};
                })
                .catch(function (error) {
                    console.error('Error reading answered questions: ', error);
                    return {evaluationId: evaluationId, porcentage: storedPorcentage};
                });
        });

        return Promise.all(progressPromises).then(function (progressResults) {
            var progressByEvaluation = {};
            progressResults.forEach(function (result) {
                progressByEvaluation[result.evaluationId] = result.porcentage;
            });

            _this.setState({
                solvedEvaluations: solvedEvaluations,
                progressByEvaluation: progressByEvaluation,
                solvedEvaluationsLoaded: true
            });
        });
    }

    getUserAccessSeries() {
        var _this = this;
        database
            .collection('users/' + _this.state.userId + '/accesed_series')
            .where('series_id', '==', _this.state.urlId)
            .get()
            .then(function (snapshot) {
                if (snapshot.docs.length == 0) {} else {
                    _this.setState({accessed_serie: snapshot.docs[0]});
                    _this.getSeriesInformation();
                }
            });
    }

    getUserInformation(user) {
        var _this = this;
        database
            .collection('users')
            .where('email', '==', user.email)
            .get()
            .then(function (querySnapshot) {
                querySnapshot
                    .forEach(function (doc) {
                        _this.setState({
                            user: doc.data(),
                            userId: doc.id
                        });
                        _this.getUserAccessSeries();
                    });
            })
            .catch(function (error) {});
    }

    componentDidMount() {
        const {urlId} = this.props.match.params;
        var _this = this;

        _this.setState({urlId: urlId});
        auth.onAuthStateChanged((user) => {
            if (user) {
                _this.getUserInformation(user);
            }
        });
    }

    render() {
        return (
            <div>
         
                <Button type="primary" href="/profile">
                    <Icon type="left" size="small"/>Regresar</Button>
                  
                <Row>
                    <Col key="ss" span={16}>
                        <Card className={`gx-card-metrics`}>
                            <h1 className="gx-product-title">{this.state.series.sponsor}</h1>
                            <h4>{this.state.series.evaluation_description}</h4>
                            <p>{this.state.series.sponsor_message}</p>
                            <p>{this.state.series.disclamer}</p>
                        </Card>
                    </Col>
                    <Col key="1a" span={8}>
                        <Card className={`gx-card-metrics`}>
                            <img src={this.state.series.sponsor_logo}/>
                        </Card>
                    </Col>
                    {this.state.evaluations.length > 0 && this.state.solvedEvaluationsLoaded == true
                        ? (this.state.evaluations.map((ev, index) => (
                            <Col key={index} span={24}>
                                <EvaluationPorcentage
                                    key={ev.id}
                                    width={(window.innerHeight*0.6 )*1.83}
                                    series={this.state.series}
                                    seriesId={this.state.urlId}
                                    evid={ev.id}
                                    calculatedPorcentage={this.state.progressByEvaluation[ev.id]}
                                    product={ev.data()}
                                    solvedEv={this
                                    .state
                                    .solvedEvaluations
                                    .filter((item) => item.data().evaluation_id == ev.id)}/>
                            </Col>
                        )))
                        : null}
                </Row>
                v1.8
            </div>
        );
    }
}

export default EvaluationsList;
